export default {"src":"/_next/static/media/endy.df240997.svg","height":24,"width":23,"blurWidth":0,"blurHeight":0};